import Columns from 'chameleon/ui-stack/ui/base/table/Columns';
import CustomCell from '../CustomCell';
import styles from '../styles.css';
import LabelList from '../label-list';
import AssessmentsTableRow from '../AssessmentsTableRow';
import cn from 'classnames';
import React from 'react';
import { getAssessmentLabels } from './util';

const AssessmentRow = ({
  row,
  subject,
  labelsDnDFF,
  assessmentName,
  onLabelRemoved,
}) => {
  const {
    labels: assessmentLabelIds = [],
    title: assessmentTitle,
    id: assessmentId,
    assignments,
    type,
  } = row.original;
  const { assessmentLabels, updateLabelAssociations } = getAssessmentLabels(
    subject,
    assessmentLabelIds,
  );

  const cells = [
    CustomCell(
      `${row.id}-title`,
      assessmentName,
      `${styles.table_cell} ${styles.title}`,
    ),
    CustomCell(
      `${row.id}-labels`,
      <LabelList
        labels={assessmentLabels}
        type={type}
        assessmentId={assessmentId}
        assessmentTitle={assessmentTitle}
        updateLabelAssociations={updateLabelAssociations}
        onLabelRemoved={onLabelRemoved}
      />,
      styles.light_cell,
    ),
    CustomCell(`${row.id}-${2}`, '', styles.light_cell),
    CustomCell(`${row.id}-${3}`, '', styles.light_cell),
    CustomCell(`${row.id}-${4}`, '', styles.light_cell),
    CustomCell(`${row.id}-${5}`, '', styles.light_cell),
    CustomCell(`${row.id}-${6}`, '', styles.light_cell),
  ];

  return (
    <AssessmentsTableRow
      isDisabled
      key={`${row.id}-${assessmentId}`}
      row={row}
      rowId={row.original.id}
      labelsDnDFF={labelsDnDFF}
      className={cn('border-b-0', assignments.length > 0 && styles.first_row)}
      aria-label={assessmentTitle}
    >
      <Columns cells={cells} className={styles.table_columns} />
    </AssessmentsTableRow>
  );
};

export default AssessmentRow;
